/**
 * Requests a pre-signed URL for uploading a file to S3.
 * @param {string} token - Authorization token.
 * @param {string} fileName - Name of the file to be uploaded.
 * @param {string} fileType - MIME type of the file (e.g., "image/jpeg").
 * @returns {Promise<string|false>} Pre-signed URL or false if the request fails.
 */
import axios from 'axios';

export const presignedURL = async (token, fileName, fileType) => {
  const url = `${process.env.REACT_APP_LBDA}postUploadURL`;

  try {
    const response = await axios.post(
      url,
      {
        name: fileName,
        content_Type: fileType,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.uploadURL;
  } catch (error) {
    console.error('Error obtaining pre-signed URL:', error);
    return false;
  }
};
